import * as yup from 'yup';

export default yup.object().shape({
  startDate: yup.string().required(),
  endDate: yup.string().required(),
});
